import VueRouter from 'vue-router';
import store from '../store';

const publicPages = [
  {
    path: '/login',
    name: 'login',
    meta: { layout: 'noAuthLayout' },
    component: () => import('../pages/public/Login.vue'),
  },
  {
    path: '/signup',
    name: 'signup',
    meta: { layout: 'noAuthLayout' },
    component: () => import('../pages/public/Signup.vue'),
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    meta: {
      layout: 'noAuthLayout',
      auth: false,
    },
    component: () => import('../pages/public/ForgotPassword.vue'),
  },
  {
    path: '/auth/activate/:hash',
    name: 'emailConfirm',
    meta: {
      layout: 'noAuthLayout',
      auth: false,
    },
    component: () => import('../pages/public/EmailConfirm.vue'),
  },
];
const onboardingPages = [
  {
    path: '/onboarding',
    name: 'onboarding',
    meta: {
      layout: 'noAuthLayout',
      auth: true,
    },
    component: () => import('../pages/Onboarding.vue'),
  },
  {
    path: '/onboarding/status',
    name: 'onboardingStatus',
    meta: {
      layout: 'noAuthLayout',
      auth: true,
    },
    component: () => import('../pages/OnboardingStatus.vue'),
  },
];

const clientsPages = [
  {
    path: '/clients/list',
    name: 'clientsList',
    meta: {
      layout: 'defaultLayout',
      auth: true,
    },
    component: () => import('../pages/clients/ClientsList.vue'),
  },
  {
    path: '/clients/details/:id',
    name: 'clientDetails',
    meta: {
      layout: 'defaultLayout',
      auth: true,
    },
    component: () => import('../pages/clients/ClientDetails.vue'),
  },
];

const ordersPages = [
  {
    path: '/orders/list/:status',
    name: 'OrdersList',
    meta: {
      layout: 'defaultLayout',
      auth: true,
    },
    component: () => import('../pages/orders/OrdersList.vue'),
  },
  {
    path: '/orders/details/:id',
    name: 'OrderDetails',
    meta: {
      layout: 'defaultLayout',
      auth: true,
    },
    component: () => import('../pages/orders/OrderDetails.vue'),
  },
  {
    path: '/invite-to-order/:hash',
    name: 'InviteOrder',
    meta: {
      layout: 'SocialAuthLayout',
      auth: true,
    },
    component: () => import('../pages/orders/InviteOrder.vue'),
  },
];

const lobbiesPages = [
  {
    path: '/lobbies/:status',
    name: 'LobbiesList',
    meta: {
      layout: 'defaultLayout',
      auth: true,
    },
    component: () => import('../pages/lobbies/LobbiesList.vue'),
  },
  {
    path: '/lobbies/details/:id',
    name: 'LobbiesDetails',
    meta: {
      layout: 'defaultLayout',
      auth: true,
    },
    component: () => import('../pages/lobbies/LobbyDetails.vue'),
  },
];

const routes = [
  {
    path: '*',
    redirect: '/orders/list/current',
  },
  {
    path: '/profile',
    name: 'Profile',
    meta: {
      layout: 'defaultLayout',
      auth: true,
    },
    component: () => import('../pages/Profile.vue'),
  },
  {
    path: '/payouts',
    name: 'Payouts',
    meta: {
      layout: 'defaultLayout',
      auth: true,
    },
    component: () => import('../pages/Payouts.vue'),
  },
  {
    path: '/auth/:social',
    name: 'authSocial',
    meta: {
      layout: 'SocialAuthLayout',
      auth: false,
    },
    component: () => import('../pages/public/AuthSocial.vue'),
  },
  ...publicPages,
  ...onboardingPages,
  ...ordersPages,
  ...clientsPages,
  ...lobbiesPages,
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const allowRoutes = [
    'login',
    'signup',
    'authSocial',
    'emailConfirm',
    'forgotPassword',
  ];
  if (!allowRoutes.includes(to.name)) {
    await store.dispatch('initUser');
  }

  if (store.getters.isLogged && store.getters.needOnboarding && to.name !== 'onboarding') {
    next('/onboarding');
  }

  if (store.getters.isLogged && (store.getters.boardingRejected || store.getters.boardingPending) && to.name !== 'onboardingStatus') {
    next('/onboarding/status');
  }

  if (!store.getters.isLogged && to.matched.some((record) => record.meta.auth)) {
    next('/login');
  }

  next();
});

export default router;
